import React from 'react';
import ReactDOM from 'react-dom';
import { Gmaps, Marker, InfoWindow, Circle } from 'react-gmaps';
import Firebase from 'firebase';

const params = { v: '3.exp', key: 'AIzaSyAhkUyLF1d-X4b-4s29nzI6VS1nTAh9Q68' };


export default class maps extends React.Component {
    constructor() {
        super();
        this.state = {
            center: { lat: 59.95, lng: 30.33 },
            zoom: 11
        }

    }
    onMapCreated(map) {
        map.setOptions({
            disableDefaultUI: true
        });
    }

    onDragEnd(e) {
        console.log('onDragEnd', e);
    }

    onCloseClick() {
        console.log('onCloseClick');
    }

    onClick(e) {
        console.log('onClick', e);
    }

    componentWillMount() {
        var d = new Date();
        d.setUTCHours(0, 0, 0, 0);
        const time = +d;
        var charts = this.state.chart;
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.formId + "/6/raw/data");
        dataRef.orderByChild("global/date/device").startAt(time)
            .on('value', snap => {
                var tabla = [];
                snap.forEach(function (childSnapshot) {
                    tabla.push(
                        <Marker
                            lat={childSnapshot.val().global.gps.lat}
                            lng={childSnapshot.val().global.gps.lon}
                            draggable={true}
                            onDragEnd={this.onDragEnd} />
                    )
                });
                this.setState({ markers: tabla });
            })
    }

    render() {
        return (
            <div className="card-block">
                <div className="card">
                    <div className="card-block">{
                        this.state.markers ?
                            <Gmaps
                                width="100%"
                                height={400}
                                lat={this.props.lat ? this.props.lat : -33.448592}
                                lng={this.props.lon ? this.props.lon : -70.671059}
                                zoom={15}
                                loadingMessage={'Be happy'}
                                params={params}
                                onMapCreated={this.onMapCreated}>
                                >
                        <Marker
                                    lat={this.props.lat}
                                    lng={this.props.lon}
                                    draggable={true}
                                    onDragEnd={this.onDragEnd} />
                            </Gmaps>
                            :
                            ""
                    }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/dashBoard/map.js